import { render, staticRenderFns } from "./GanarOferta.vue?vue&type=template&id=648e3fc3"
import script from "./GanarOferta.vue?vue&type=script&lang=js"
export * from "./GanarOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports